<template>
  <div class="quote-detail__header-seasonal">
    <div class="sk-heading-small-semibold">
      {{ scopeName }}
    </div>
    <MonthlyUsersFluctuactionBreakdown
      :seasonality-fluctuation-months="seasonalityFluctuationMonths"
      :additional-user-price="additionalUserPrice"
      :locale="locale"
    />
    <div class="quote-detail__header-seasonal__infos">
      <div
        v-for="(info, index) in seasonalInfos"
        :key="index"
        class="quote-detail__header-seasonal__info"
      >
        <span class="sk-text-small-regular text--grey">
          {{ info.label }}
        </span>
        <span class="sk-text-small-regular">
          {{ info.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import MonthlyUsersFluctuactionBreakdown from '@/shared/components/MonthlyUsersFluctuactionBreakdown/index.vue';

export default {
  name: 'QuoteDetailSeasonalHeader',
  components: {
    MonthlyUsersFluctuactionBreakdown,
  },
  props: {
    scopeName: {
      type: String,
      required: true,
    },
    seasonalityFluctuationMonths: {
      type: Object,
      required: true,
    },
    additionalUserPrice: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    commitment: {
      type: String,
      required: true,
    },
    payment_frequency: {
      type: String,
      required: true,
    },
  },
  computed: {
    seasonalInfos() {
      return [
        {
          label: this.$t('quote_details.commitment.label'),
          value: this.commitment,
        },
        {
          label: this.$t('quote_details.billing_cycle.label'),
          value: this.payment_frequency,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.quote-detail__header-seasonal {
  background-color: $sk-grey-5;
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  align-self: stretch;
}

.quote-detail__header-seasonal__infos {
  display: flex;
  align-items: center;
  align-content: center;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;
}

.quote-detail__header-seasonal__info {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
